import invariant from 'invariant'
import {
  CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL,
  CONFIRM_ACTION_SET_NEXT_ACTION,
  CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL
} from 'actions/confirm-action/constants'
import { isFSA } from 'flux-standard-action'

let initialState = {
  nextAction: null,
  showConfirmActionModal: false
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )
  let {payload} = action

  switch (action.type) {
    case CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL:
      return {...state, showConfirmActionModal: true}
    case CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL:
      return {...state, showConfirmActionModal: false}
    case CONFIRM_ACTION_SET_NEXT_ACTION:
      return {...state, nextAction: payload.nextAction}
    default:
      return {...state}
  }
}

export {reducer}



// WEBPACK FOOTER //
// ./app/reducers/confirm-action.js